import { useCallback } from 'react';
import { Avatar, Col, Row } from 'antd';
import { Logo, Button, PageLayout, ContentLayout } from 'components';
import style from './index.module.scss';
import { useNavigate } from 'react-router-dom';
import { ROUTE } from 'routers/data';
import { useAuth } from 'hooks/useAuth';

export const Login = () => {
  const { googleSignIn } = useAuth();
  const navigation = useNavigate();

  const navSignIn = useCallback(() => {
    navigation(ROUTE.signIn);
  }, [navigation]);

  const navSignUp = useCallback(() => {
    navigation(ROUTE.signUp);
  }, [navigation]);

  return (
    <PageLayout>
      <ContentLayout>
        <Logo className={style.logo} />
        <Row justify={'center'}>
          <Col>
            <Button
              onClick={navSignUp}
              className={style.button}
              buttonType="solid"
              shape="round"
            >
              REGISTRARSE
            </Button>
          </Col>
        </Row>
        <Row justify={'center'}>
          <Col>
            <Button
              onClick={navSignIn}
              className={style.button}
              buttonType="outline"
              shape="round"
            >
              INGRESAR
            </Button>
          </Col>
        </Row>
        <Row justify={'center'}>
          <Col>
            <Avatar
              onClick={googleSignIn}
              className={style.google}
              src="assets\icon\google.svg"
            />
          </Col>
        </Row>
      </ContentLayout>
    </PageLayout>
  );
};
